import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export const getSampling = async (productId: string, id: string) => {
  try {
    const response = await apiService.get<any>(
      `/products/${productId}/samples/${id}`
    );

    return response;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getSampling;
